import { createEventDateFormatter } from '../date/createEventDateFormatter'
import { formatMoney } from '~/utils/money'

export const getDateForHumans = ({ startDate, endDate }, language = 'en') => {
  const formatEventDate = createEventDateFormatter(language)
  return formatEventDate(startDate, endDate)
}

// Example:
// Tue, October 1 • Paradiso, Amsterdam
export const getEventDescription = (
  { startDate, endDate, location, hasOngoingEventType },
  language
) => {
  const date = hasOngoingEventType ? null : getDateForHumans({ startDate, endDate }, language)
  const locationName = location && location.name
  const locationCity = location && location.city && location.city.name
  const venueList = [locationName, locationCity]
  const venue = venueList.filter((el, index) => venueList.indexOf(el) === index).join(', ')

  return [date, venue].filter(el => el).join(' • ')
}

export const getEventLocation = ({ location }) => {
  const locationName = location && location.name
  const locationCity = location && location.city && location.city.name
  const countryName = location && location.country && location.country.name
  const venueList = [locationName, locationCity, countryName]
  const venue = venueList.filter((el, index) => el && venueList.indexOf(el) === index).join(', ')
  return venue
}

// Example:
// Zitplaats Rank 2 - Seating
export const getEventTypeTitle = (
  { title, seatingOptions, originalTicketPrice },
  seatingLabelText,
  locale
) => {
  const hasSeating =
    Object.keys(seatingOptions).filter(key => seatingOptions[key] === true).length > 0
  const seatingLabel = hasSeating && seatingLabelText
  const ticketPrice = originalTicketPrice && formatMoney(originalTicketPrice, locale)

  return [title, seatingLabel, ticketPrice].filter(el => el).join(' - ')
}
